export default {
  hour: '時',
  year: '年',
  month: '月',
  day: '日',
  weekDays: {
    sunday: '日',
    monday: '月',
    tuesday: '火',
    wednesday: '水',
    thursday: '木',
    friday: '金',
    saturday: '土'
  }
};
